import { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import logo from '../../assets/logo.png';
import Axios from '../../Axios';
import toast from 'react-hot-toast';

export default function SplashPage() {

  const [params] = useSearchParams();
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const rawTarget = location.state?.targetPath || location.state?.from;
  const targetPath =
    typeof rawTarget === 'string' &&
    rawTarget.startsWith('/') &&
    !['/authenticating', '/login', '/401'].includes(rawTarget)
      ? rawTarget
      : '/';

  const exchangeAttempted = useRef(false);

  useEffect(() => {
    if (exchangeAttempted.current) return;
    exchangeAttempted.current = true;
    
    const exchange = async () => {
      try {
        const code = params.get("code");

        if (!code) {
          console.log("🚀 ~ exchange ~ code:", code)
          navigate('/401');
          return;
        }

        const { data } = await Axios.post(
          "/authenticate-trader",
          { code }
        );

        if (data.success) {
          localStorage.setItem("olympusMons", data.result?.token);
          localStorage.setItem("tradeMode", data.result?.mode);
          setTimeout(() => {
            navigate(targetPath, { replace: true });
          }, 3000);
        } else {
          toast.error(data.message);
          navigate('/401');
        }

      } catch (err) {
        toast.error("Something went wrong");
        navigate('/401');
      }
    };

    exchange();
  }, [navigate, params, targetPath]);

  useEffect(() => {
    const duration = 2500;
    const intervalTime = 25;
    const steps = duration / intervalTime;
    let currentStep = 0;

    const interval = setInterval(() => {
      currentStep++;
      const newProgress = Math.min(Math.floor((currentStep / steps) * 100), 100);
      setProgress(newProgress);

      if (currentStep >= steps) {
        clearInterval(interval);
        setTimeout(() => {
          navigate(targetPath, { replace: true });
        }, 250);
      }
    }, intervalTime);

    return () => clearInterval(interval);
  }, [navigate, targetPath]);

  return (
    <main className="relative grid min-h-screen w-full place-items-center overflow-hidden bg-[radial-gradient(circle_at_12%_10%,rgba(252,68,32,0.18),transparent_36%),radial-gradient(circle_at_88%_14%,rgba(252,68,32,0.10),transparent_30%),radial-gradient(circle_at_85%_85%,rgba(252,68,32,0.22),transparent_46%),linear-gradient(180deg,#120402_0%,#1a0603_52%,#0d0302_100%)] px-6">
      <section
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,rgba(176,255,215,0.03)_1px,transparent_1px),linear-gradient(to_bottom,rgba(176,255,215,0.03)_1px,transparent_1px)] bg-[size:34px_34px]"
      />
      <section
        aria-hidden="true"
        className="pointer-events-none absolute -right-28 -top-28 h-80 w-80 rounded-full bg-[#FC4420]/20 blur-3xl"
      />
      <section
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-[#FC4420]/20 blur-3xl"
      />

      <div className="relative z-10 flex w-full max-w-sm flex-col items-center">
        <div className="mb-10 w-[190px]">
          <img
            src={logo}
            alt="Logo"
            className="h-auto w-full animate-pulse drop-shadow-[0_0_18px_rgba(252,68,32,0.28)]"
            style={{ animationDuration: '2.6s' }}
          />
        </div>

        <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.42em] text-[#ff9b88]">
          Authenticating
        </p>

        <div className="w-full">
          <div className="mx-auto flex w-full max-w-[280px] items-center gap-3">
            <div className="h-2 w-full overflow-hidden rounded-full border border-[#FC4420]/25 bg-black/35 shadow-[inset_0_1px_2px_rgba(255,255,255,0.06)]">
              <div
                className="h-full rounded-full bg-[#FC4420] transition-all duration-[25ms] ease-linear shadow-[0_0_14px_rgba(252,68,32,0.45)]"
                style={{ width: `${Math.max(progress, 6)}%` }}
              />
            </div>
            <p className="min-w-[44px] text-right text-xs font-semibold tabular-nums tracking-[0.12em] text-white">
              {progress}%
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}
